import { Observable } from 'rxjs';
import { BaseInput, BaseInputConstructor } from './base-input';

interface LabelValue<T, E> {
    label: T;
    value: E;
}

export type SelectOption<LABEL = string, VALUE = string> = LabelValue<LABEL, VALUE>;

export interface SelectInputConstructor<T, E> extends BaseInputConstructor<T> {
    options: Observable<SelectOption<T, E>[]>;
}

export class SelectInput<T = string, E = string> extends BaseInput<T> {
    override inputType = 'select';
    override readonly __internalConstructor__: SelectInputConstructor<T, E>;
    options: Observable<SelectOption<T, E>[]>;

    constructor(options: SelectInputConstructor<T, E>) {
        super(options);
        this.__internalConstructor__ = options;
        this.options = options.options;
    }

    clone(): SelectInput<T, E> {
        return new SelectInput(this.__internalConstructor__);
    }
}
